// Client-side validation for raw-JSON textarea fields. The wire carries jsonb columns as strings
// (parsed to JsonElement? at the controller boundary), so the form validates parseability before
// submit; empty/whitespace input serializes as null.

type JsonFieldResult = { ok: true; normalized: string | null } | { ok: false; error: string };

// specs/metadata: any valid JSON (matches the server's ParseJson, which accepts any JSON value).
export function validateJsonText(text: string): JsonFieldResult {
  const trimmed = text.trim();
  if (!trimmed) return { ok: true, normalized: null };
  try {
    JSON.parse(trimmed);
    return { ok: true, normalized: trimmed };
  } catch {
    return { ok: false, error: "Must be valid JSON" };
  }
}

// tracking_config: the epic contract is {"sub_id_param": "<query-param name>"} — a JSON object with
// a non-empty string sub_id_param. Extra keys are allowed (the server stores freeform jsonb; a
// structured editor is deferred).
export function validateTrackingConfig(text: string): JsonFieldResult {
  const trimmed = text.trim();
  if (!trimmed) return { ok: true, normalized: null };
  let parsed: unknown;
  try {
    parsed = JSON.parse(trimmed);
  } catch {
    return { ok: false, error: "Must be valid JSON" };
  }
  if (typeof parsed !== "object" || parsed === null || Array.isArray(parsed)) {
    return { ok: false, error: 'Must be a JSON object, e.g. {"sub_id_param": "clickref"}' };
  }
  const subIdParam = (parsed as Record<string, unknown>).sub_id_param;
  if (typeof subIdParam !== "string" || subIdParam.length === 0) {
    return { ok: false, error: 'Must contain a non-empty string "sub_id_param"' };
  }
  return { ok: true, normalized: trimmed };
}
